import { createAsyncThunk, createSlice, original } from "@reduxjs/toolkit";
import { getGenieProperties } from "./genieApi";
import { isAxiosError } from "axios";
import { setGlobalMsgAlerts } from "../../components/GloablMsgAlerts/globalMsgAlertsSlice";

interface stateType {
  status: "idle" | "loading" | "failed" | "successful";
  properties: {
    moleculeData: [];
    statsSummary: [];
    interactionsSet: [];
    singleSmileData: {
      id: number;
      rankRowData: any[];
      evaluationIds: number[];
      data: any;
      jobId: string;
    };
    jobId: string;
  };
}

const initialState: stateType = {
  status: "idle",
  properties: {
    moleculeData: [],
    statsSummary: [],
    interactionsSet: [],
    singleSmileData: {
      id: -1,
      rankRowData: [],
      evaluationIds: [],
      data: null,
      jobId: "",
    },
    jobId: "",
  },
};

export const fetchGenieProperties = createAsyncThunk(
  "genie/fetchGenieProperties",
  async (task_id: string, { dispatch }) => {
    try {
      const response = await getGenieProperties(task_id);
      return response.data;
    } catch (error) {
      let msg = "";
      if (isAxiosError(error)) {
        msg = error.response.data?.detail?.message;
      }
      dispatch(
        setGlobalMsgAlerts({
          msg: msg,
          isAlert: true,
          color: "error",
        })
      );
      throw msg;
    }
  }
);

export const genieSlice = createSlice({
  name: "genie",
  initialState,
  reducers: {
    setSingleSmileData: (state, action) => {
      state.properties.singleSmileData.id = action.payload.id;
      state.properties.singleSmileData.rankRowData = action.payload.rankRowData;
      state.properties.singleSmileData.evaluationIds =
        action.payload.evaluationIds;
      state.properties.singleSmileData.data = action.payload.data;
      state.properties.singleSmileData.jobId = action.payload.jobId;
    },
    updateSmilesById: (state, action) => {
      const { id } = action.payload;
      const sliceData = original(state.properties.singleSmileData);
      const smilesData = sliceData.rankRowData[sliceData.evaluationIds[id] - 1];
      state.properties.singleSmileData.id = id;
      state.properties.singleSmileData.data = smilesData;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGenieProperties.fulfilled, (state, action) => {
        state.properties.moleculeData = action.payload.molecules;
        state.properties.interactionsSet =
          action.payload.interactions_set.sort();
          state.properties.statsSummary = action.payload.stats;
        state.properties.jobId = action.payload.task_id;
        state.status = "successful";
      })
      .addCase(fetchGenieProperties.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(fetchGenieProperties.pending, (state) => {
        state.status = "loading";
      });
  },
});
export const { setSingleSmileData, updateSmilesById } = genieSlice.actions;
export default genieSlice.reducer;
